/**
 * GB API
 * API for GB Component
 *
 * The version of the OpenAPI document: -
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { EigentumListEntry } from '../model/models';
import { EigentumanteilMasterId } from '../model/models';
import { GrundstueckId } from '../model/models';
import { LoadEigentumanteilSichtByGrundstueckIdResponseMeta } from '../model/models';
import { LoadEigentumanteilSichtPersonstammResponseMeta } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class GbeigentumService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }



    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * @param masterId 
     * @param historisiert 
     * @param versionId 
     * @param timepoint 
     * @param timepointId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getById(masterId: string, historisiert: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST', versionId?: string, timepoint?: string, timepointId?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<EigentumListEntry>;
    public getById(masterId: string, historisiert: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST', versionId?: string, timepoint?: string, timepointId?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<EigentumListEntry>>;
    public getById(masterId: string, historisiert: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST', versionId?: string, timepoint?: string, timepointId?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<EigentumListEntry>>;
    public getById(masterId: string, historisiert: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST', versionId?: string, timepoint?: string, timepointId?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (masterId === null || masterId === undefined) {
            throw new Error('Required parameter masterId was null or undefined when calling getById.');
        }
        if (historisiert === null || historisiert === undefined) {
            throw new Error('Required parameter historisiert was null or undefined when calling getById.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (versionId !== undefined && versionId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>versionId, 'versionId');
        }
        if (timepoint !== undefined && timepoint !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>timepoint, 'timepoint');
        }
        if (timepointId !== undefined && timepointId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>timepointId, 'timepointId');
        }
        if (historisiert !== undefined && historisiert !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>historisiert, 'historisiert');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<EigentumListEntry>(`${this.configuration.basePath}/gb/eigentum/${encodeURIComponent(String(masterId))}`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param grundstueckId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public loadBodengrundstueckVon(grundstueckId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<GrundstueckId>;
    public loadBodengrundstueckVon(grundstueckId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<GrundstueckId>>;
    public loadBodengrundstueckVon(grundstueckId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<GrundstueckId>>;
    public loadBodengrundstueckVon(grundstueckId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (grundstueckId === null || grundstueckId === undefined) {
            throw new Error('Required parameter grundstueckId was null or undefined when calling loadBodengrundstueckVon.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (grundstueckId !== undefined && grundstueckId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>grundstueckId, 'grundstueckId');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<GrundstueckId>(`${this.configuration.basePath}/gb/eigentum/bodengrundstueck`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param id 
     * @param eigentumErweitert 
     * @param mode 
     * @param historisiert 
     * @param timepoint 
     * @param timepointId 
     * @param off 
     * @param lim 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public loadEigentumSichtGbMeldung(id: string, eigentumErweitert: boolean, mode: 'BELASTET' | 'BERECHTIGT_NORMAL' | 'BERECHTIGT_SUBJEKTIV_DINGLICH', historisiert: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST', timepoint?: string, timepointId?: string, off?: number, lim?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<LoadEigentumanteilSichtByGrundstueckIdResponseMeta>;
    public loadEigentumSichtGbMeldung(id: string, eigentumErweitert: boolean, mode: 'BELASTET' | 'BERECHTIGT_NORMAL' | 'BERECHTIGT_SUBJEKTIV_DINGLICH', historisiert: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST', timepoint?: string, timepointId?: string, off?: number, lim?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<LoadEigentumanteilSichtByGrundstueckIdResponseMeta>>;
    public loadEigentumSichtGbMeldung(id: string, eigentumErweitert: boolean, mode: 'BELASTET' | 'BERECHTIGT_NORMAL' | 'BERECHTIGT_SUBJEKTIV_DINGLICH', historisiert: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST', timepoint?: string, timepointId?: string, off?: number, lim?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<LoadEigentumanteilSichtByGrundstueckIdResponseMeta>>;
    public loadEigentumSichtGbMeldung(id: string, eigentumErweitert: boolean, mode: 'BELASTET' | 'BERECHTIGT_NORMAL' | 'BERECHTIGT_SUBJEKTIV_DINGLICH', historisiert: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST', timepoint?: string, timepointId?: string, off?: number, lim?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling loadEigentumSichtGbMeldung.');
        }
        if (eigentumErweitert === null || eigentumErweitert === undefined) {
            throw new Error('Required parameter eigentumErweitert was null or undefined when calling loadEigentumSichtGbMeldung.');
        }
        if (mode === null || mode === undefined) {
            throw new Error('Required parameter mode was null or undefined when calling loadEigentumSichtGbMeldung.');
        }
        if (historisiert === null || historisiert === undefined) {
            throw new Error('Required parameter historisiert was null or undefined when calling loadEigentumSichtGbMeldung.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (id !== undefined && id !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>id, 'id');
        }
        if (eigentumErweitert !== undefined && eigentumErweitert !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>eigentumErweitert, 'eigentumErweitert');
        }
        if (mode !== undefined && mode !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>mode, 'mode');
        }
        if (timepoint !== undefined && timepoint !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>timepoint, 'timepoint');
        }
        if (timepointId !== undefined && timepointId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>timepointId, 'timepointId');
        }
        if (historisiert !== undefined && historisiert !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>historisiert, 'historisiert');
        }
        if (off !== undefined && off !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>off, 'off');
        }
        if (lim !== undefined && lim !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>lim, 'lim');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<LoadEigentumanteilSichtByGrundstueckIdResponseMeta>(`${this.configuration.basePath}/gb/eigentum/sicht/grundstueck/gbmeldung`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param id 
     * @param eigentumErweitert 
     * @param mode 
     * @param historisiert 
     * @param timepoint 
     * @param timepointId 
     * @param off 
     * @param lim 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public loadEigentumSichtGrundstueck(id: string, eigentumErweitert: boolean, mode: 'BELASTET' | 'BERECHTIGT_NORMAL' | 'BERECHTIGT_SUBJEKTIV_DINGLICH', historisiert: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST', timepoint?: string, timepointId?: string, off?: number, lim?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<LoadEigentumanteilSichtByGrundstueckIdResponseMeta>;
    public loadEigentumSichtGrundstueck(id: string, eigentumErweitert: boolean, mode: 'BELASTET' | 'BERECHTIGT_NORMAL' | 'BERECHTIGT_SUBJEKTIV_DINGLICH', historisiert: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST', timepoint?: string, timepointId?: string, off?: number, lim?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<LoadEigentumanteilSichtByGrundstueckIdResponseMeta>>;
    public loadEigentumSichtGrundstueck(id: string, eigentumErweitert: boolean, mode: 'BELASTET' | 'BERECHTIGT_NORMAL' | 'BERECHTIGT_SUBJEKTIV_DINGLICH', historisiert: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST', timepoint?: string, timepointId?: string, off?: number, lim?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<LoadEigentumanteilSichtByGrundstueckIdResponseMeta>>;
    public loadEigentumSichtGrundstueck(id: string, eigentumErweitert: boolean, mode: 'BELASTET' | 'BERECHTIGT_NORMAL' | 'BERECHTIGT_SUBJEKTIV_DINGLICH', historisiert: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST', timepoint?: string, timepointId?: string, off?: number, lim?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling loadEigentumSichtGrundstueck.');
        }
        if (eigentumErweitert === null || eigentumErweitert === undefined) {
            throw new Error('Required parameter eigentumErweitert was null or undefined when calling loadEigentumSichtGrundstueck.');
        }
        if (mode === null || mode === undefined) {
            throw new Error('Required parameter mode was null or undefined when calling loadEigentumSichtGrundstueck.');
        }
        if (historisiert === null || historisiert === undefined) {
            throw new Error('Required parameter historisiert was null or undefined when calling loadEigentumSichtGrundstueck.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (id !== undefined && id !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>id, 'id');
        }
        if (eigentumErweitert !== undefined && eigentumErweitert !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>eigentumErweitert, 'eigentumErweitert');
        }
        if (mode !== undefined && mode !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>mode, 'mode');
        }
        if (timepoint !== undefined && timepoint !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>timepoint, 'timepoint');
        }
        if (timepointId !== undefined && timepointId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>timepointId, 'timepointId');
        }
        if (historisiert !== undefined && historisiert !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>historisiert, 'historisiert');
        }
        if (off !== undefined && off !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>off, 'off');
        }
        if (lim !== undefined && lim !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>lim, 'lim');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<LoadEigentumanteilSichtByGrundstueckIdResponseMeta>(`${this.configuration.basePath}/gb/eigentum/sicht/grundstueck`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param personStammMasterId 
     * @param eigentumanteilMasterIds 
     * @param timepoint 
     * @param timepointId 
     * @param historisiert 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public loadEigentumSichtPersonstamm(personStammMasterId: string, eigentumanteilMasterIds: Array<string>, timepoint?: string, timepointId?: string, historisiert?: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<LoadEigentumanteilSichtPersonstammResponseMeta>;
    public loadEigentumSichtPersonstamm(personStammMasterId: string, eigentumanteilMasterIds: Array<string>, timepoint?: string, timepointId?: string, historisiert?: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<LoadEigentumanteilSichtPersonstammResponseMeta>>;
    public loadEigentumSichtPersonstamm(personStammMasterId: string, eigentumanteilMasterIds: Array<string>, timepoint?: string, timepointId?: string, historisiert?: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<LoadEigentumanteilSichtPersonstammResponseMeta>>;
    public loadEigentumSichtPersonstamm(personStammMasterId: string, eigentumanteilMasterIds: Array<string>, timepoint?: string, timepointId?: string, historisiert?: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (personStammMasterId === null || personStammMasterId === undefined) {
            throw new Error('Required parameter personStammMasterId was null or undefined when calling loadEigentumSichtPersonstamm.');
        }
        if (eigentumanteilMasterIds === null || eigentumanteilMasterIds === undefined) {
            throw new Error('Required parameter eigentumanteilMasterIds was null or undefined when calling loadEigentumSichtPersonstamm.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (personStammMasterId !== undefined && personStammMasterId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>personStammMasterId, 'personStammMasterId');
        }
        if (eigentumanteilMasterIds) {
            eigentumanteilMasterIds.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'EigentumanteilMasterIds');
            })
        }
        if (timepoint !== undefined && timepoint !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>timepoint, 'timepoint');
        }
        if (timepointId !== undefined && timepointId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>timepointId, 'timepointId');
        }
        if (historisiert !== undefined && historisiert !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>historisiert, 'historisiert');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<LoadEigentumanteilSichtPersonstammResponseMeta>(`${this.configuration.basePath}/gb/eigentum/sicht/person`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param personStammMasterId 
     * @param timepoint 
     * @param timepointId 
     * @param historisiert 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public loadEigentumanteilMasterIdsSichtPersonstamm(personStammMasterId: string, timepoint?: string, timepointId?: string, historisiert?: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Array<EigentumanteilMasterId>>;
    public loadEigentumanteilMasterIdsSichtPersonstamm(personStammMasterId: string, timepoint?: string, timepointId?: string, historisiert?: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Array<EigentumanteilMasterId>>>;
    public loadEigentumanteilMasterIdsSichtPersonstamm(personStammMasterId: string, timepoint?: string, timepointId?: string, historisiert?: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Array<EigentumanteilMasterId>>>;
    public loadEigentumanteilMasterIdsSichtPersonstamm(personStammMasterId: string, timepoint?: string, timepointId?: string, historisiert?: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (personStammMasterId === null || personStammMasterId === undefined) {
            throw new Error('Required parameter personStammMasterId was null or undefined when calling loadEigentumanteilMasterIdsSichtPersonstamm.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (personStammMasterId !== undefined && personStammMasterId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>personStammMasterId, 'personStammMasterId');
        }
        if (timepoint !== undefined && timepoint !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>timepoint, 'timepoint');
        }
        if (timepointId !== undefined && timepointId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>timepointId, 'timepointId');
        }
        if (historisiert !== undefined && historisiert !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>historisiert, 'historisiert');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<Array<EigentumanteilMasterId>>(`${this.configuration.basePath}/gb/eigentum/sicht/person/id`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
